module.exports = __webpack_public_path__ + "static/img/car10.28e7a26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/car10.png
// module id = WL8K
// module chunks = 1